<script>
import {defineComponent} from "vue";
import headtip from "@/views/headTip.vue";
import consultTip from "@/components/consultTip.vue";

export default defineComponent({
  components: {consultTip, headtip},
  data(){
    return{
      dialogVisible: false,
      title: 'GPT Assistants',
    }

  },
  methods:{
    clickConsult(item) {

      console.log(item)
      this.title = item
      this.dialogVisible = true;
      sessionStorage.setItem('title', item)
    },
    hideDialog() {
      localStorage.setItem("skip", 0)
      this.dialogVisible = false;
    },

  }
})
</script>

<template>
  <div class="assistantsContainer">
    <div class="header" style="padding:1.5vh 5vw;background-color: #f2f1f4">
      <headtip @showDialog="showPartner"></headtip>
    </div>
    <a href="/">
      <div style="position: absolute;top: 70px;left: 10px">
        <img style="width: 40px;height: 20px" src="@/assets/back1.png">
      </div>
    </a>

    <div class="title1">Open Claw</div>
    <div class="assistants" style="display: grid;grid-template-columns: minmax(0,1fr) ;padding: 0 5vw;margin-top: 6vh">
      <a href="https://console.volcengine.com/ark/claw " target="_blank">
        <div class="assistant" >
          <img  src="@/assets/openclaw/zijie.svg">
          <div class="contentDesign">
            <div class="t1">字节ArkClaw</div>
            <div class="t2">
              深度适配飞书生态，低代码一键部署，让你的 AI Agent 快速落地，高效赋能业务协作！  
            </div>
          </div>
        </div>
      </a>
      <a href="https://www.codebuddy.cn/work" target="_blank">
        <div class="assistant">
          <img  src="@/assets/openclaw/tengxun.svg">
          <div class="contentDesign">
            <div class="t1">腾讯 WorkBuddy</div>
            <div class="t2">
              深度集成企微 / QQ 能力，一键打通团队沟通与任务流，全面提升协作效率，办公更省心！
            </div>
          </div>
        </div>
      </a>
      <a href="https://activity.huaweicloud.com/openclaw.html" target="_blank">
        <div class="assistant">
        <img  src="@/assets/openclaw/huawei.svg">
        <div class="contentDesign">
          <div class="t1">华为OpenClaw</div>
          <div class="t2">
            华为云一键部署，满足高安全合规要求，为企业级 AI 应用提供稳定可靠的技术底座！
          </div>
        </div>
      </div>
      </a>
      <a href="https://www.aliyun.com/activity/ecs/clawdbot" target="_blank">
        <div class="assistant">
        <img  src="@/assets/openclaw/ali.svg">
        <div class="contentDesign">
          <div class="t1">阿里OpenClaw</div>
          <div class="t2">
            集成 AgentBay 企业级托管能力，完美适配云原生场景，让 AI 服务弹性扩容、高效运行！
          </div>
        </div>
      </div>
      </a>
      <a href="https://console.bce.baidu.com/qianfan/studio/openclaw" target="_blank">
        <div class="assistant">
          <img  src="@/assets/openclaw/baidu.svg">
          <div class="contentDesign">
            <div class="t1">百度OpenClaw</div>
            <div class="t2">
              3-5 分钟快速体验，支持 App 搜索框直接调用，开箱即用，轻松构建行业 AI 应用！
            </div>
          </div>
        </div>
      </a>
      <a href="https://www.kimi.com/bot" target="_blank">
        <div class="assistant">
          <img  src="@/assets/openclaw/kimi.svg">
          <div class="contentDesign">
            <div class="t1">Kimi Claw</div>
            <div class="t2">
              集成 Kimi 大模型，超强文档问答，一键接入生态，赋能知识管理与智能办公！
            </div>
          </div>
        </div>
      </a>

    </div>
    <consultTip
        :thisTitle="title"
        :dialogVisible="dialogVisible"
        @hideDialog="hideDialog"
    ></consultTip>
  </div>
</template>

<style scoped lang="scss">
.assistantsContainer{
  width: 100%;
  .topback {
    position: fixed;
    z-index: 9;
    width: 100vw;
    padding: 0 0 0 2.86077411900635vw;
  }
  .title1{
    font-size: 6vw;
    margin: 1vh  auto auto;
    padding: 2vh 0;
    text-align: center;
    font-weight: bolder;
  }
  .title2{
    font-size: 4vw;
    text-align: left;
  }
  .assistant{
    margin: 1vh 2vh;
    padding: 2vh;
    border-radius: 9px;
    //padding: 4vh 6vw 4vh 2vw;
    display: flex;
    align-items: center;
    background-color: white;
    //border: 1px solid gray;
    img{
      width: 12vw;
      height: 12vw;
    }
    .contentDesign{
      margin-left: 4vw;
      .t1{
        font-size: 4vw;
        font-weight: bolder;
      }
      .t2{
        margin-top: 1vh;
        font-size: 3vw;
      }
    }
  }
}

</style>
